import { BASE_PARAMS } from "../constants/api"
import { api } from '.'


export const commission = {
  get: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.list`,
    }
    return api.get('/', { params })
  },
  getById: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.get`,
    }
    return api.get('/', { params })
  },
  create: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.create`,
    }
    return api.get('/', { params })
  },
  update: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.update`,
    }
    return api.get('/', { params })
  },
  delete: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.delete`,
    }
    return api.get('/', { params })
  },
}

export const peoples = {
  get: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.people`,
    }
    return api.get('/', { params })
  }
}

export const members = {
  get: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.members`,
    }
    return api.get('/', { params })
  },
  add: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.member.add`,
    }
    return api.get('/', { params })
  },
  update: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.member.update`,
    }
    return api.get('/', { params })
  },
  delete: payload => {
    const params = {
      ...BASE_PARAMS,
      ...payload,
      action: `commission.member.delete`,
    }
    return api.get('/', { params })
  },
}